<template>
  <section class="module-section">
    <div class="portal-grid">
      <template
        v-for="card in portalCards"
        :key="card.title"
      >
        <RouterLink
          v-if="card.type === 'route'"
          :to="card.to"
          class="portal-card"
          :class="{ featured: card.featured }"
        >
          <div class="portal-media">
            <img :src="card.image" :alt="card.alt">
            <div class="portal-overlay"></div>
          </div>

          <div class="card-body">
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
        </RouterLink>

        <a
          v-else
          :href="card.href"
          target="_blank"
          rel="noopener noreferrer"
          class="portal-card"
          :class="{ featured: card.featured }"
        >
          <div class="portal-media">
            <img :src="card.image" :alt="card.alt">
            <div class="portal-overlay"></div>
          </div>

          <div class="card-body">
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
        </a>
      </template>
    </div>
  </section>
</template>

<script setup>
import { watchEffect } from "vue";
import { RouterLink } from "vue-router";
import { useContentStore } from "@/store/contentStore";

const { portalCards } = useContentStore();

watchEffect(() => {
  document.title = "圣域空间 | 首页";
});
</script>
